import { render, staticRenderFns } from "./homePie.vue?vue&type=template&id=6d63b1b4&scoped=true"
import script from "./homePie.vue?vue&type=script&lang=js"
export * from "./homePie.vue?vue&type=script&lang=js"
import style0 from "./homePie.vue?vue&type=style&index=0&id=6d63b1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63b1b4",
  null
  
)

export default component.exports